/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import { AxiosUtil } from 'src/utils';
import InterpreterDisplayResponse from "src/models/generated/InterpreterDisplayResponse";
import InterpreterSearchRequest from "src/models/generated/InterpreterSearchRequest";
import TableResponse from "src/models/generated/TableResponse";
import TimeIntervalDTO from "src/models/generated/TimeIntervalDTO";

export class UserController {
    /**
     * get: /api/User/getHomepageList
     */
    public getHomepageList() {
        const route = `api/User/getHomepageList`;
        return AxiosUtil.get<InterpreterDisplayResponse[]>(route, items => items.map(InterpreterDisplayResponse.create));
    }

    /**
     * Gets the interpreter by the publicId
     * get: /api/User/getInterpreter/${encodeURIComponent(publicId)}
     */
    public getInterpreterById(publicId: string) {
        const route = `api/User/getInterpreter/${encodeURIComponent(publicId)}`;
        return AxiosUtil.get<InterpreterDisplayResponse>(route, InterpreterDisplayResponse.create);
    }

    /**
     * get: /api/User/getInterpreterAvailability/${encodeURIComponent(publicId)}?timezone=${encodeURIComponent(timezone)}
     */
    public getInterpreterAvailability(publicId: string, timezone: string) {
        const route = `api/User/getInterpreterAvailability/${encodeURIComponent(publicId)}?timezone=${encodeURIComponent(timezone)}`;
        return AxiosUtil.get<TimeIntervalDTO[]>(route, items => items.map(TimeIntervalDTO.create));
    }

    /**
     * post: /api/User/searchInterpreters
     */
    public searchInterpreters(searchRequest: InterpreterSearchRequest) {
        const route = `api/User/searchInterpreters`;
        return AxiosUtil.post<TableResponse<InterpreterDisplayResponse>, InterpreterSearchRequest>(route, searchRequest, TableResponse.create<InterpreterDisplayResponse>);
    }
}

export default new UserController();
